import { Region } from '../region';
import { IPaymentProvider } from '../../providers/payment/payment.interface'
import { PaymentProviderFiserv } from '../../providers/payment/payment.fiserv'
import { DirectBankBrand } from '../../model/types/payment-method-type';
/**
 * @description Geographical region the application is currently configured for, e.g. US, Spain, Australia.
 * @region Enumeration for this region.
 * @defaultCountryFrom Default value to use for send-from country, i.e. in price calculator
 * @defaultCurrencyFrom Default value to use for send-from currency, i.e. in price calculator
 * @defaultLanguage Default language culture to use, i.e. content translations
 */
export const regionValues = {
  region: Region.AU,
  regionId: 705,
  defaultCountryFrom: 'AU',
  defaultCountryFromOnfido: 'AUS',
  defaultCountryCodeFrom: 61,
  defaultCurrencyFrom: 'AUD',
  defaultAmountFrom: 100,
  defaultLanguageCulture: 'en-AU',
  defaultLocation: {
    latitude: -35.2809,
    longitude: 149.1300
  },
  dateFormat: 'DD/MM/YYYY',
  postalCodeRegex:`^\\d{4}$`,
  links: {
    linkFaq: 'https://www.riamoneytransfer.com/us/en/mobile-content/faqs'
  },
  languageCultures: ['en-AU', 'tl-AU', 'th-AU', 'vi-AU'],
  regionalIp: '66.82.123.234',
  paymentProvider: <IPaymentProvider>new PaymentProviderFiserv(),
  isPlaidEnabled: false,
  isBankAccountEnabled:false,
  useSecurityQuestions: false,
  oldRemittanceLogin: false,
  onfidoMaxAttempts: 0,
  directBankBrand:DirectBankBrand.PoliPay,
  distanceMetric: 'km',
  acceptInternationalCards:false,
  stagedRiaBrand: '',
  payNearMeBrand: '',
  isEu: false,
  isEMEA: false,
  notShowMarketingPushAlert: true,
  useVeriff: false,
  googlepayAdyenPaymentNetworks: ["masterCard", "visa"],
  applepayAdyenPaymentNetworks: ["eftpos", "masterCard", "visa"],
  adyenMerchantCapability: ["debit", "3ds", "credit"],
  walletSettings:{
    isMerchantSupportEnable:false,
  },
  defaultTranslationParams: null,
  originalCountryAllowedOnly: false,
  canShowLogosOnQRScanner: false,
  airtimeServices:{
    isAirTimeSevice:false,
    isLocalOnly:false,
  },
  passCodeLength: 6,
  showNewHomePage: true,
  walletServices:[],
  isCountrySupportDecimal: true,
  autoEnableMarketingPreference: false,
  loginRootHomePage: "activity",
  adyenRegion: 'live-au' // https://docs.adyen.com/development-resources/live-endpoints/#client-side-environment-region
};



// WEBPACK FOOTER //
// ./src/environment/region/AU.ts